<div class="homeSideBar">
    <div class="homeLoginArea">
        <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_CHANGEPROFILE_TITLE' | translate"></span>
        <div class="departureTimeListArea">
            <div class="tab-pane">
                <p class="formPagesInfoText ng-binding" [innerHTML]="'ACCOUNT_CHANGEPROFILE_DESCRIPTION' | translate"></p>
                <input class="formInput phoneNumberWrapperInputs" type="text" minlength="2" [(ngModel)]="name" [placeholder]="'ACCOUNT_CHANGEPROFILE_NAME' | translate" required>
                <input class="formInput phoneNumberWrapperInputs" type="text" minlength="2" [(ngModel)]="surname" [placeholder]="'ACCOUNT_CHANGEPROFILE_SURNAME' | translate" required>
                <input class="formInput phoneNumberWrapperInputs" type="password" minlength="2" maxlength="6" [(ngModel)]="password" [placeholder]="'ACCOUNT_CHANGEPIN_OLD_PASSWORD_PLACEHOLDER' | translate" required>
                <app-loading-animation [isRouting]="isHideSendButton" [margin]="'20px auto'" [width]="80">
                    <a 
                        type="button" 
                        class="formButton" 
                        (click)="saveChanges()" 
                        [innerHTML]="'ACCOUNT_CHANGEPROFILE_SUBMIT_CHANGES' | translate"
                    >
                    </a>
                </app-loading-animation>
            </div>
        </div>
    </div>
    <app-download-app></app-download-app>
</div>